<script>
import resources from './resources'

export default {
  name: 'professional-agendas-form',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Cadastro de Agenda Profissional", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          v-if='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Agenda incluida com sucesso.',
          :buttonsNext='nextStepButtonsRules')

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Agenda alterada com sucesso.',
          :buttonsNext='nextStepButtonsRules',
          v-if="beenUpdated")

        ul.nav.nav-tabs
          li
            router-link(:to="{name: 'professional.agenda.agendas.index'}")
              a(href="#") Listagem
          li.active
            a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              form.col-sm-10
                h4 AGENDA PROFISSIONAL — CADASTRO
                .form-group
                  .row
                    .col-xs-12
                      v-input(:status="$v.agenda.company_address_id.$error ? 'error' : null")
                        f-select-company-address(label="Localidade",
                          :disabled="!(!agenda.id)",
                           name="company_address_id",
                           v-model="agenda.company_address_id",
                           :searchable="true",
                           :get-all="true",
                           @selected="getProfessionalCompany",
                           :errors="errors['company_address_id']")

                  template(v-if="userIsCompany")
                    .row
                      .col-xs-12
                        f-select(label="Profissional",
                          :disabled="!(!agenda.id)",
                          name="professional_id",
                          v-model="agenda.professional_id",
                          :searchable="true",
                          :options="optionsCompanyProfessional",
                          @selected="setSpecialitiesFromProfessional")

                        //-f-select-company-staff(label="Profissional",
                          :disabled="!(!agenda.id)",
                           name="professional_id",
                           v-model="agenda.professional_id",
                           :searchable="true",
                           :get-all="true",
                           @selected="setSpecialitiesFromProfessional",
                           :errors="errors['professional_id']")


                    .row(v-if="agenda.professional_id")
                      .col-xs-12
                        f-select-custom(label="Especialidade",
                          name="specialities",
                          v-model="agenda.specialities",
                          :multiple="true",
                          :disabled="!(!agenda.id)",
                          :limit="3",
                          :searchable="true",
                          :options="optionsCompanyProfessionalSpecialities")

                        //--f-select-company-speciality(label="Especialidade",
                          v-if="!loading",
                          :disabled="!(!agenda.id)",
                          name="specialities",
                          v-model="agenda.specialities",
                          :multiple="true",
                          :parameters="{professional_id: agenda.professional_id}"
                          :errors="errors['specialities']")

                  .row(v-if="!userIsCompany")
                    .col-xs-12
                      v-input(:status="$v.agenda.specialities.$error ? 'error' : null")
                        f-select-custom(label="Especialidade",
                          name="specialities",
                          v-model="agenda.specialities",
                          :multiple="true",
                          :disabled="!(!agenda.id)",
                          :limit="3",
                          :searchable="true",
                          :options="optionsProfessionalSpecialities")

                        //-f-select-professional-speciality(label="Especialidade",
                          v-if="!loading",
                          name="specialities",
                          :disabled="!(!agenda.id)",
                          v-model="agenda.specialities",
                          :multiple="true",
                          :get-all="true",
                          :errors="errors['specialities']")
                  .row
                    .col-xs-12
                      v-input(:status="$v.agenda.name.$error ? 'error' : null")
                        f-text(label="Nome da Agenda"
                          v-model="agenda.name",
                          name="name",
                          :maxlength="30",
                          :errors="errors['name']")

                  .row
                    .col-xs-12.col-sm-3.margin-bottom(v-if="userIsCompany")
                      f-select-yes-no(label="Triagem",
                        name="screening",
                        v-model="agenda.screening",
                        :searchable="false",
                        :errors="errors['screening']")

                    .col-xs-12.col-sm-3.margin-bottom(v-if="userIsCompany")
                      f-select-yes-no(label="Call Center",
                       name="agenda",
                       v-model="agenda.callcenter",
                       :searchable="false",
                       :errors="errors['callcenter']")

                    .col-xs-12.col-sm-3.margin-bottom
                      f-select-yes-no(label="Ativa",
                       name="active",
                       v-model="agenda.active",
                       :searchable="false",
                       :errors="errors['active']")

                    .col-xs-12.col-sm-3.margin-bottom
                      f-select-yes-no(label="Publica",
                       name="public",
                       v-model="agenda.public",
                       :searchable="false",
                       :errors="errors['public']")

                    .col-xs-12.margin-bottom(:class="{'col-sm-12': userIsCompany, 'col-sm-6': !userIsCompany}")
                      f-select-net-treatment(label="Rede de Atendimento",
                       name="service_network",
                       v-model="agenda.service_network",
                       :searchable="false",
                       @selected="idPrivate",
                       :errors="errors['service_network']")
                  //-- .row(v-if="convenantHidden")
                  .row
                    .col-xs-12
                      .form-group
                        v-input(:status="$v.agenda.covenants.$error ? 'error' : null")
                          f-select-company-covenant(
                            v-if="!loading",
                            label="Convênios Médicos",
                            v-model="agenda.covenants",
                            name="covenants",
                            :get-all="true"
                            :searchable="true",
                            :multiple="true",
                            :limit="100",
                            :disabled="!(!agendaIsPrivate)"
                            :errors="errors['covenants']")

                .buttons-wrapper
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/professional/agenda/agendas/form/form.vue